import { render, staticRenderFns } from "./quotationSupplierCreate.vue?vue&type=template&id=2d7310b9&scoped=true"
import script from "./quotationSupplierCreate.vue?vue&type=script&lang=js"
export * from "./quotationSupplierCreate.vue?vue&type=script&lang=js"
import style0 from "./quotationSupplierCreate.vue?vue&type=style&index=0&id=2d7310b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7310b9",
  null
  
)

export default component.exports